import { useEffect, useState } from 'react'
import { I18nextProvider, initReactI18next } from 'react-i18next'

import { clsx } from 'clsx'
import { createInstance, i18n as I18nInstance } from 'i18next'

import { useTravelSearchConfig } from './Hooks/useTravelSearchConfig'

import { SkeletonLoader } from './componentsnew/SkeletonLoader'
import { TravelSearch } from './componentsnew/TravelSearch'
import { getBaseApi, getLocaleFromUrlOrQuery } from './Utils'
import { fetcher } from './Utils/fetcher'

const baseApi = getBaseApi()

interface Props {
  hasOffer?: boolean
}

const AppWithContent = ({ hasOffer }: Props) => {
  const locale = getLocaleFromUrlOrQuery()
  const [ready, setReady] = useState(false)
  const [content, setContent] = useState<any>(null)
  const [i18Instance, setI18Instance] = useState<I18nInstance | null>(null)
  const travelSearchConfig = useTravelSearchConfig()
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [minTimeElapsed, setMinTimeElapsed] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setMinTimeElapsed(true), 1000)
    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    if (!locale) return

    let canceled = false
    const url = `${baseApi}/content?locale=${locale}`

    fetcher<{ content: any }>(url)
      .then((res) => {
        if (!canceled) {
          setContent(res.content)
        }
      })
      .catch(() => {
        return
      })

    return () => {
      canceled = true
    }
  }, [locale])

  useEffect(() => {
    if (!content || !locale) return
    const instance = createInstance()
    instance
      .use(initReactI18next)
      .init({
        debug: false,
        fallbackLng: 'en',
        interpolation: { escapeValue: false },
        lng: locale,
        resources: {},
      })
      .then(() => {
        instance.addResourceBundle(locale.substring(0, 2), 'translation', content)
        setI18Instance(instance)
      })
      .catch(() => {
        return
      })
  }, [content, locale])

  useEffect(() => {
    if (!travelSearchConfig.isLoading) {
      if (travelSearchConfig.isMultiOffer !== undefined) {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setReady(true)
      } else {
        if (window.location.hostname !== 'www.dfds.com') {
          setErrorMessage(`AvailableMinibooks: ${travelSearchConfig.availableMinibooks}, isMultiOffer: ${travelSearchConfig.isMultiOffer}`)
        }
        setReady(true)
      }
    }
  }, [travelSearchConfig])

  // Show loading skeleton until the i18n instance  is ready and the travel search config is loaded
  if (!ready || !i18Instance || !minTimeElapsed) {
    return (
      <div className={clsx({ 'p-semantic-global-lg': window.location.hostname === 'localhost' })} id="travel-search-loading">
        {hasOffer ? <div>Offer skeletons todo</div> : <SkeletonLoader />}
      </div>
    )
  }

  return (
    <div className={clsx({ 'p-semantic-global-lg': window.location.hostname === 'localhost' })} id="travel-search">
      <I18nextProvider i18n={i18Instance}>
        <TravelSearch errorMessage={errorMessage} travelSearchConfigResult={travelSearchConfig} />
      </I18nextProvider>
    </div>
  )
}

export default AppWithContent
